<script>
  import { useForm } from '@inertiajs/svelte'
  import FlashMessage from '../../components/flash_message.svelte'
  import LegacyCmsBanner from '../../components/legacy_cms_banner.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  let { reset_password_token = '', minimum_password_length = 8 } = $props()

  const form = useForm({
    admin_site_admin: {
      reset_password_token,
      password: '',
      password_confirmation: ''
    }
  }).withPrecognition('put', '/reset-password')
  // Validation is the server's: live Precognition requests to the real action, and on submit.
  liveValidate(form, 'admin_site_admin')

  function submit(e) {
    e.preventDefault()
    $form.put('/reset-password')
  }
</script>

<LegacyCmsBanner />
<div class="min-h-screen bg-base-200 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
  <FlashMessage />
  <div class="card bg-base-100 shadow-md p-8 w-full max-w-md space-y-8">
    <h2 class="text-lg font-bold text-center">Set a new password</h2>

    <form novalidate onsubmit={submit} class="space-y-4">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">New password</legend>
        <input
          type="password"
          bind:value={$form.admin_site_admin.password}
          class="input w-full"
          class:input-error={$form.errors['admin_site_admin.password']}
          autocomplete="new-password"
        />
        {#if $form.errors['admin_site_admin.password']}
          <div class="text-error text-sm mt-1">{$form.errors['admin_site_admin.password']}</div>
        {/if}
      </fieldset>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">Confirm new password</legend>
        <input
          type="password"
          bind:value={$form.admin_site_admin.password_confirmation}
          class="input w-full"
          class:input-error={$form.errors['admin_site_admin.password_confirmation']}
          autocomplete="new-password"
        />
        {#if $form.errors['admin_site_admin.password_confirmation']}
          <div class="text-error text-sm mt-1">{$form.errors['admin_site_admin.password_confirmation']}</div>
        {/if}
      </fieldset>

      <Button type="submit" variant="primary" block loading={$form.processing}>Reset password</Button>
    </form>
  </div>
</div>
